export default __webpack_public_path__ + "media/images/icons/icon-slider-back-3f09327c17f87af4e91439d3ae4e7796.svg";